import { en } from './content/en';
import { fr } from './content/fr';
import { MENTORING_LOCALES, MENTORING_PAGES, getMentoringPath } from './mentoringRoutes';
import { formatCohortDate, getNextSaturday } from './nextCohort';

const contentByLocale = Object.freeze({ fr, en });

// Paths that live on the host CSL BRANDS site rather than in this section.
export const HOST_PATHS = Object.freeze({
  contact: '/contact',
  hostPrivacy: '/privacy-policy',
  hostTerms: '/terms-of-service',
  hostSitemap: '/sitemap',
});

export const getMentoringContent = (locale) => {
  if (!MENTORING_LOCALES.includes(locale)) return undefined;

  const source = contentByLocale[locale];
  const date = formatCohortDate(getNextSaturday(), locale);
  const isEnglish = locale === 'en';
  const cohortFacts = source.shared.cohortFacts.map((fact, index) => (
    index === 0 ? { ...fact, value: date } : fact
  ));
  const waysCards = source.index.waysIn.cards.map((card) => (
    card.target === 'contact' && card.key === (isEnglish ? 'mentee' : 'mentore')
      ? { ...card, text: isEnglish ? `Apply to Cohort 01 — starts ${date}.` : `Candidature au Cohort 01 — démarrage le ${date}.` }
      : card
  ));

  return {
    ...source,
    shared: {
      ...source.shared,
      cohortFacts,
      cta: {
        ...source.shared.cta,
        kicker: isEnglish ? `Next cohort — ${date}` : `Prochaine promo — ${date}`,
      },
    },
    index: {
      ...source.index,
      hero: { ...source.index.hero, facts: cohortFacts },
      waysIn: { ...source.index.waysIn, cards: waysCards },
    },
    program: {
      ...source.program,
      hero: { ...source.program.hero, facts: cohortFacts },
    },
  };
};

export const getMentoringPageContent = (locale, pageKey) => {
  const content = getMentoringContent(locale);

  if (!content || !MENTORING_PAGES.includes(pageKey)) {
    return undefined;
  }

  return content[pageKey];
};

/** Nav, marquee, closing CTA and footer copy — identical across all pages. */
export const getMentoringSharedContent = (locale) => getMentoringContent(locale)?.shared;

export const getMentoringSeo = (locale, pageKey) => (
  getMentoringContent(locale)?.seo?.[pageKey]
);

/**
 * Resolves a content `target` key to an href. Page keys become the
 * locale-prefixed path for the current language; everything else falls back to
 * the host-site path map. Returns undefined for unknown targets so a content
 * typo renders nothing instead of a dead link.
 */
export const resolveMentoringTarget = (target, locale) => {
  if (typeof target !== 'string') {
    return undefined;
  }

  if (Object.prototype.hasOwnProperty.call(HOST_PATHS, target)) {
    return HOST_PATHS[target];
  }

  return getMentoringPath(locale, target);
};
